import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import connect from "react-redux/es/connect/connect";

import {format} from "date-fns-tz";
import * as ptBR from "date-fns/locale/pt-BR";

import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Xrange from 'highcharts/modules/xrange';
import Accessibility from 'highcharts/modules/accessibility';
import {COLOR_chart_series_first_line} from "../../../common/CustomTheme/ThemeDefault/colors";

HighchartsMore(ReactHighcharts.Highcharts);
Xrange(ReactHighcharts.Highcharts);
Accessibility(ReactHighcharts.Highcharts);


//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
    progress: {
        margin: theme.spacing(1) * 2,
    },

}));

interface Custom extends ReactHighcharts.PointOptionsObject {
    autoclaveId: number;
    ciclo: number;
    data: string;
    minutos: number;
    minH: string;
    maxH: string;
}


const hhmmStr = (currentTime) => {
    var currentHours = ('0'+currentTime.getHours()).substr(-2);
    var currentMin = ('0'+currentTime.getMinutes()).substr(-2);
    return currentHours+':'+currentMin;
}


const AutoclaveCiclosUtilizacaoChart = ({
                               dados
}) => {


  const classes = useStyles();





    //const { autoclaveId, dados } = dados;
    //const { ciclosDados } = this.props.autoclaves;




    let ixseries = -1; // ciclosDados.findIndex( (c) => parseInt( c.autoclaveId) === parseInt(autoclaveId) && c.ciclo.toString() === cicloId.toString());


    let x1 = 0;
    let x2 = 0;
    let xd;
    let dd = "";
    let idias = -1;
    let dias = []
    let ser  = []
    let dmin = 0
    let dmax = 0;

    dados.map((d,ix) => {



        let dobj = d;

        dmin = new Date(dobj.minH);
        dmax = new Date(dobj.maxH);

        // if (d.ciclo === 5177) {
        //     console.log("getDate", dmin.getDate(), dmax.getDate());
        //     debugger;
        // }

        if (dmin.getDate() !== dmax.getDate()) {
            // se inicio for D e final D+1 (pós meia noite)
           // console.log("dmin !== dmax", dmin, dmax);
            while (dmin.getDate() !== dmax.getDate() ) {

               // console.log("while iniciando add data", dobj.minH);

                xd = new Date(dobj.minH);
                dd = `${xd.getFullYear()}-${xd.getMonth()+1}-${xd.getDate()}`;
                idias = dias.findIndex((di) => di === dd);
                if (idias < 0) {
                    dias.push(dd);
                    idias = dias.length - 1;
                }

                x1 = dmin.getHours() + (dmin.getMinutes() / 60);
                x2 = 24;
                ser.push(
                    {
                        x: x1,
                        x2: x2,
                        y: idias,
                        partialFill: (Math.round(dobj.pneus / dobj.capacidade * 100) / 100).toFixed(1),
                        custom: {
                            ...dobj
                        },
                        color: COLOR_chart_series_first_line,
                    }
                );

                dmin.setDate(dmin.getDate() + 1);
                dmin.setHours(0, 0, 0, 0);
                dobj.minH = new Date(dmin).toISOString();
                dmax = new Date(dobj.maxH);
              //  console.log("while alterando data", dobj.minH);

            }

            xd = new Date(dobj.minH);
            dd = `${xd.getFullYear()}-${xd.getMonth()+1}-${xd.getDate()}`;
            idias = dias.findIndex((di) => di === dd);
            if (idias < 0) {
                dias.push(dd);
                idias = dias.length - 1;
            }

                x1 = new Date(d.minH).getHours() + (new Date(d.minH).getMinutes() / 60);
                x2 = new Date(d.maxH).getHours() + (new Date(d.maxH).getMinutes() / 60);
                ser.push(
                    {
                        x:  x1,
                        x2: x2,
                        y: idias,
                        partialFill: (Math.round(d.pneus / d.capacidade * 100) /100).toFixed(1) ,
                        custom: {
                            ...d
                        },
                        color: COLOR_chart_series_first_line,

                    }
                );



        } else {
            xd = new Date(d.minH);
            dd = `${xd.getFullYear()}-${xd.getMonth()+1}-${xd.getDate()}`;

            idias = dias.findIndex((di) => di === dd);
            if (idias < 0) {
                dias.push(dd  );
                idias = dias.length-1;
            }

            x1 = new Date(d.minH).getHours() + (new Date(d.minH).getMinutes() / 60);
            x2 = new Date(d.maxH).getHours() + (new Date(d.maxH).getMinutes() / 60);
           // console.log("xi", x1,x2);
            ser.push(
                {
                    x:  x1,
                    x2: x2,
                    y: idias,
                    partialFill: (Math.round(d.pneus / d.capacidade * 100) /100).toFixed(1) ,
                    custom: {
                        ...d
                    },
                    color: COLOR_chart_series_first_line,

                }
            );
        }


    });

  //  console.log("props dados", dados);
  //  console.log("dias", dias);
  //  console.log("serie", ser);

    var chartdata = {
        chart: {
            type: 'xrange',
            zoomType: 'xy',
            height: '100%'
        },
        title: {
            text: `Ciclos da autoclave ${ser[0]? ser[0].custom.codigo : ''}`
        },
        partialFill: {
          fill: COLOR_chart_series_first_line,
        },
        plotOptions: {
            xrange: {
                tooltip: {
                    headerFormat: '<span style="font-size: 10px">{point.yCategory}</span><br/>',
                    pointFormatter: function () {
                        // var custom :Custom = point.options ;
                        // console.log("point.descriptionFormatter",point.x, point.x2, point.yCategory);
                        var ix = this.index,
                            category = this.yCategory,
                            from = new Date(this.x),
                            to = new Date(this.x2);

                        return `<span>autoclave: ${this.custom.autoclaveId}=${this.custom.codigo}; ciclo: ${this.custom.ciclo}; pneus: ${this.custom.pneus}/${this.custom.capacidade}</span><br><span>horário: ${hhmmStr(new Date(this.custom.minH))}h  -> ${hhmmStr(new Date(this.custom.maxH))}h;  duração: ${this.custom.minutos}min</span>`;
                    }
                },
                point: {
                    events: {
                        click: function () {
                            alert('Category: ' + this.category + ', value: ' + this.y + ' ' + this.x + ' ' + this.x2 + ' '  );
                        }
                    }
                }
            }
        },
        xAxis: {
            type: 'linear',
            min: 0,
            max: 24
        },
        yAxis: {
            title: {
                text: ''
            },
            categories: dias,
            reversed: true
        },
        series: [
            {
                name : 'Autoclave',
                // keys: ['custom.autoclaveId',  'custom.ciclo', 'custom.data', 'custom.maxH',  'custom.minH', 'x', 'x2', 'y'],
                data: ser,
                dataLabels: {
                        enabled: true
                    }
            }
        ]

    }

    // const sersample = {
    //     name: 'Project 1',
    //         // pointPadding: 0,
    //         // groupPadding: 0,
    //         borderColor: 'gray',
    //     pointWidth: 20,
    //     data: [{
    //     x: Date.UTC(2014, 10, 21),
    //     x2: Date.UTC(2014, 11, 2),
    //     y: 0,
    //     partialFill: 0.25
    // }, {
    //     x: Date.UTC(2014, 11, 2),
    //     x2: Date.UTC(2014, 11, 5),
    //     y: 1
    // }, {
    //     x: Date.UTC(2014, 11, 8),
    //     x2: Date.UTC(2014, 11, 9),
    //     y: 2
    // }, {
    //     x: Date.UTC(2014, 11, 9),
    //     x2: Date.UTC(2014, 11, 19),
    //     y: 1
    // }, {
    //     x: Date.UTC(2014, 11, 10),
    //     x2: Date.UTC(2014, 11, 23),
    //     y: 2
    // }],
    //     dataLabels: {
    //     enabled: true
    // }
    // }





    return (
        <React.Fragment>

            <ReactHighcharts config = {chartdata} styles={{ height: '100%' }} ></ReactHighcharts>

        </React.Fragment>
    );


}

const mapStateToProps = state => {
  return {
  }
}

export default connect(mapStateToProps, {
})(AutoclaveCiclosUtilizacaoChart)
